import type React from 'react';
import { useMemo } from 'react';

import { useGetFace, useGetFaces } from '@vlabs/api/artemy/client';
import type { FaceId } from '@vlabs/api/artemy/model';
import { FaceCardPoint3 } from '@vlabs/monokit/shared/ui/face-card/FaceCard.point3';
// ponytail: depends on commented createCardFromFaceFormSubmitHandlerPoint3, GUI-3979
// import { AttachFaceToCardButton } from '@vlabs/monokit/widgets/attach-face-to-card-button/AttachFaceToCardButton.point3';
import { useTranslation } from 'react-i18next';

import st from './SameExternalIdFacesSection.module.sass';
import { PageSection } from '../../page-section';

interface SameExternalIdFacesSectionProps {
  faceId: FaceId;
}

function SameExternalIdFacesSection({
  faceId,
}: SameExternalIdFacesSectionProps): React.ReactNode {
  const { t } = useTranslation();
  const getCurrentFace = useGetFace(faceId);
  const getFaces = useGetFaces({ card_ids: getCurrentFace.data?.card_id ? [getCurrentFace.data.card_id] : undefined }, {
    query: {
      enabled: !!getCurrentFace.data?.card_id,
    },
  });

  const faces = useMemo(() => getFaces.data?.faces?.map((face) => {
    if (face.face_id === faceId) return undefined;
    return (
      <FaceCardPoint3
        can={() => true}
        faceId={face.face_id}
        key={face.face_id}
        size="small"
      />
    );
  }).filter((f) => f !== undefined) ?? [], [faceId, getFaces.data?.faces]);

  if (!getCurrentFace.isFetched) return null;

  return (
    <PageSection title={t('face-page:same_external_id_faces.title')}>
      {!!getCurrentFace.data?.card_id && faces.length > 0 && <div className={st.Faces}>{faces}</div>}
      {!!getCurrentFace.data?.card_id && faces.length === 0 && (t('face-page:same_external_id_faces.no_faces')) }
      {/* ponytail: depends on commented createCardFromFaceFormSubmitHandlerPoint3, GUI-3979
      {!getCurrentFace.data?.card_id && (
        <div className={st.NoFaces}>
          <AttachFaceToCardButton
            faceId={faceId}
            onAttachFaceToCard={({ fromState, cardId }) => {
              if (fromState === 'create') {
                history.push(generatePath(routes.externalId.read, { externalId: cardId }));
              }
            }}
          />
        </div>
      )}
      */}
    </PageSection>
  );
}

export { SameExternalIdFacesSection };
